import { Button } from '@/components/ui/button'
import { AlertCircle } from 'lucide-react'
import {
    Alert,
    AlertTitle,
    AlertDescription,
} from "@/components/ui/alert"

/**
 * Alert shown when viewing a historical version of content
 */
export function VersionAlert({ onRestoreClick }: { onRestoreClick: () => void }) {
    return (
        <Alert className="mb-4">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Viewing Historical Version</AlertTitle>
            <AlertDescription className="flex items-center justify-between">
                <span>You can only improve the current version. Restore this version first if you want to make improvements to it.</span>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={onRestoreClick}
                    className="ml-4 whitespace-nowrap"
                >
                    Restore Version
                </Button>
            </AlertDescription>
        </Alert>
    )
}